import Directory from '../../component/category-directory/categrory-directory-component';
const Home = () => {

  return (
     <Directory ></Directory>
  );
}

export default Home;
